import Vue from 'vue'
import Vuex from 'vuex'
import 'firebase/auth'

// imported modules
import authentication from "./modules/user_related_transactions"
import firestore_transaction from "./modules/firestore_transactions"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    homeSelectedComponent: '',
    collaborativeTaskListSelectedTab: '',
    creationModalSelectedComponent: '',
    creationModalTitle: ''
  },
  getters: {
    homeSelectedComponent: state => {
      return state.homeSelectedComponent
    },
    collaborativeTaskListSelectedTab: state => {
      return state.collaborativeTaskListSelectedTab
    },
    creationModalSelectedComponent: state => {
      return state.creationModalSelectedComponent
    },
    creationModalTitle: state => {
      return state.creationModalTitle
    }
  },
  mutations: {
    updateHomeSelectedComponent: (state, payload) => {
      state.homeSelectedComponent = payload
    },
    updateCollaborativeTaskListSelectedTab: (state, payload) => {
      state.collaborativeTaskListSelectedTab = payload
    },
    updateCreationModalSelectedComponent: (state, value) => {
      state.creationModalSelectedComponent = value
    },
    updateCreationModalTitle: (state, value) => {
      state.creationModalTitle = value
    }
  },
  actions: {
    updateHomeSelectedComponent: ({commit}, payload) => {
      commit('updateHomeSelectedComponent', payload)
    },
    updateCollaborativeTaskListSelectedTab: ({commit}, payload) => {
      commit('updateCollaborativeTaskListSelectedTab', payload)
    },
    updateCreationModalSelectedComponent: ({commit}, payload) => {
      commit('updateCreationModalSelectedComponent', payload)
    },
    updateCreationModalTitle: ({commit}, payload) => {
      commit('updateCreationModalTitle', payload)
    },
    updateListCategory: ({state, commit}, payload) => {
      if (payload === state.homeSelectedComponent) {
        return
      }

      commit('updateHomeSelectedComponent', payload)
    },
    setupCreationModal: ({state, commit}) => {
      if (state.homeSelectedComponent === 'inbox' || state.homeSelectedComponent === 'personalTaskList') {
        commit('updateCreationModalSelectedComponent', 'personalTaskCreation')
        commit('updateCreationModalTitle', 'Create Personal Task')
      } else if (state.homeSelectedComponent === 'collaborativeTaskList') {
        commit('updateCreationModalSelectedComponent', 'collaborativeTaskCreation')
        commit('updateCreationModalTitle', 'Create Collaborative Task')
      } else if (state.homeSelectedComponent === 'personalList') {
        commit('updateCreationModalSelectedComponent', 'personalListCreation')
        commit('updateCreationModalTitle', 'Create Personal List')
      } else if (state.homeSelectedComponent === 'collaborativeList') {
        commit('updateCreationModalSelectedComponent', 'collaborativeListCreation')
        commit('updateCreationModalTitle', 'Create Collaborative List')
      } else if (state.homeSelectedComponent === 'viewCollaborators') {
        commit('updateCreationModalSelectedComponent', 'inviteListCollaborator')
        commit('updateCreationModalTitle', 'Invite List Collaborator')
      }
    },
  },
  modules: {
    authentication,
    firestore_transaction
  }
})
